var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7322 14.6816L7.73215 29.6816C7.58379 29.84 7.38796 29.9457 7.1742 29.983C6.96045 30.0203 6.74037 29.987 6.54718 29.8882C6.354 29.7895 6.19818 29.6305 6.10324 29.4354C6.00831 29.2403 5.97941 29.0196 6.0209 28.8066L7.8534 19.6404L0.64965 16.9354C0.49494 16.8775 0.356974 16.7822 0.248079 16.658C0.139184 16.5338 0.062751 16.3846 0.0256088 16.2236C-0.0115334 16.0627 -0.00822786 15.895 0.0352299 15.7357C0.0786877 15.5763 0.160944 15.4302 0.27465 15.3104L14.2747 0.310381C14.423 0.152051 14.6188 0.0462705 14.8326 0.00900269C15.0464 -0.0282652 15.2664 0.0050017 15.4596 0.103783C15.6528 0.202565 15.8086 0.361501 15.9036 0.556609C15.9985 0.751716 16.0274 0.972408 15.9859 1.18538L14.1484 10.3616L21.3521 13.0629C21.5057 13.1211 21.6426 13.2163 21.7506 13.34C21.8587 13.4637 21.9346 13.6122 21.9717 13.7722C22.0087 13.9322 22.0058 14.0989 21.9632 14.2575C21.9205 14.4161 21.8395 14.5618 21.7271 14.6816H21.7322Z",
    fill: "url(#paint0_linear_668_26069)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_26069",
    x1: -6.55575e-7,
    y1: 29.9979,
    x2: 29.1934,
    y2: 18.8668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnger);
export default __webpack_public_path__ + "static/media/Anger.20c5186d4f094e4c60ad19042273c168.svg";
export { ForwardRef as ReactComponent };